/**
 * Druck: vor dem Druck alle Akkordeons und Tab-Panels öffnen, Bilder sofort
 * laden und den Links im Text ihre absolute Adresse mitgeben (print.css zeigt
 * sie an). Nach dem Druck wird der vorherige Zustand wiederhergestellt.
 * CSS allein reicht nicht: [hidden] ist in reset.css !important.
 */
const LINKS = ':is(.ce-bodytext, .rte, .ce-uploads, .c-linkbox) a[href]:not([href^="#"]):not([href^="javascript:"])';

const bare = (url) => url.trim().toLowerCase().replace(/^[a-z]+:\/\//, '').replace(/^www\./, '').replace(/\/$/, '');

export function initPrint() {
  let restore = [];

  window.addEventListener('beforeprint', () => {
    if (restore.length) return;
    /* deeplink.js schreibt beim Öffnen eines Akkordeons sonst dessen #id in die Adresse */
    document.documentElement.dataset.printing = '';
    const main = document.getElementById('main') || document.body;

    main.querySelectorAll('details:not([open])').forEach((d) => {
      d.open = true;
      restore.push(() => { d.open = false; });
    });
    main.querySelectorAll('.c-tabs [hidden]').forEach((el) => {
      el.hidden = false;
      restore.push(() => { el.hidden = true; });
    });
    main.querySelectorAll('img[loading="lazy"]').forEach((img) => {
      img.loading = 'eager';
      restore.push(() => { img.loading = 'lazy'; });
    });
    main.querySelectorAll(LINKS).forEach((a) => {
      const url = a.href.replace(/^mailto:/, '');
      /* Linktext ist schon die Adresse („www.carsharing.de“): leer lassen, print.css zeigt dann nichts */
      a.dataset.printUrl = bare(a.textContent) === bare(url) ? '' : url;
      restore.push(() => { delete a.dataset.printUrl; });
    });
  });

  window.addEventListener('afterprint', () => {
    restore.forEach((fn) => fn());
    restore = [];
    /* erst nach den toggle-Events, die das Öffnen und Schließen ausgelöst hat */
    setTimeout(() => { delete document.documentElement.dataset.printing; });
  });
}
